<div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

        <!-- Content area -->
        <div class="content d-flex justify-content-center align-items-center">

            <!-- Container -->
            <div class="flex-fill content-error">

                <!-- Error title -->
                <div class="text-center mb-1">
                    <h5 class="error-text">{{ 'modules.auth.google.callback.description' | translate }}</h5>
                </div>
                <!-- /error title -->
                <!-- Error content -->
                <div class="row">
                    <div class="col-xl-4 offset-xl-4 col-md-8 offset-md-2">

                    </div>
                </div>
                <!-- /error wrapper -->
            </div>
            <!-- /container -->
        </div>
        <!-- /content area -->
    </div>
    <!-- /main content -->
</div>
